import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Slider from 'react-slick';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(
          'https://www.startupbusinesspartners.com/api/testimonials',
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          }
        );
        
        if (response.data.success) {
          setTestimonials(response.data.data);
        } else {
          throw new Error(response.data.message || 'Failed to fetch testimonials');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching testimonials:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1 },
      }
    ],
    appendDots: dots => (
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <ul style={{ margin: 0, padding: 0 }}>{dots}</ul>
      </div>
    ),
    customPaging: i => (
      <button style={{
        width: '15px',
        height: '15px',
        borderRadius: '50%',
        background: '#ccc',
        border: 'none'
      }} />
    ),
  };

  if (loading) {
    return (
      <section style={{ padding: '25px 0', textAlign: 'center' }}>
        <p>Loading testimonials...</p>
      </section>
    );
  }

  if (error) {
    return (
      <section style={{ padding: '25px 0', textAlign: 'center', color: 'red' }}>
        <p>Error loading testimonials: {error}</p>
      </section>
    );
  }

  return (
    <section style={{ padding: '25px 0', backgroundColor: '#f9f9f9' }}>
      <div style={{ marginBottom: '35px', textAlign: 'center' }}>
        <h1>Client Testimonials </h1>
      </div>

      {testimonials.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p>No testimonials available yet.</p>
        </div>
      ) : (
        <div style={{ maxWidth: '1140px', margin: '0 auto' }}>
          <Slider {...settings}>
            {testimonials.map((item, index) => (
              <div key={item.id} style={{ padding: '20px' }}>
                <div style={{ padding: '30px', marginRight: '20px' }}>
                  <p style={{
                    marginBottom: '20px',
                    fontStyle: 'italic',
                    boxShadow: '0 5px 30px rgba(105, 106, 119, 0.1)',
                    padding: '30px'
                  }}>
                    {item.text}
                  </p>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                      <img 
                  src={`https://www.startupbusinesspartners.com/uploads/cms/${item.image || ''}`}
                        alt={item.author} 
                        style={{ 
                          width: '60px', 
                          height: '60px', 
                          borderRadius: '50%', 
                          marginRight: '20px',
                          objectFit: 'cover'
                        }} 
                      />
                    </div>
                    <div>
                      <h6 style={{ margin: '0 0 5px 0' }}>{item.author}</h6>
                      <span style={{ color: 'rgb(72 181 161)' }}>
                        {item.designation && `${item.designation}, `}{item.company}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </section>
  );
};

export default Testimonials;